import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const USER_KEY = "uci_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const cached = localStorage.getItem(USER_KEY);
    const token = getToken();
    if (token && cached) {
      // Trust cached session immediately (offline-first), validate in background.
      setUser(JSON.parse(cached));
      setReady(true);
      if (navigator.onLine) {
        api
          .get("/auth/me")
          .then(({ data }) => {
            setUser(data.user);
            localStorage.setItem(USER_KEY, JSON.stringify(data.user));
          })
          .catch((e) => {
            if (e?.response?.status === 401) logout();
          });
      }
    } else {
      setUser(null);
      setReady(true);
    }
    // eslint-disable-next-line
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }

  async function register(name, email, password) {
    const { data } = await api.post("/auth/register", { name, email, password });
    if (data.pending) return { pending: true, message: data.message };
    setToken(data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    setUser(data.user);
    return { pending: false, user: data.user };
  }

  function logout() {
    api.post("/auth/logout").catch(() => {});
    setToken("");
    localStorage.removeItem(USER_KEY);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}
